import { usePrivate } from '@/components/private';
import useSWRMutation from 'swr/mutation';

type TDeleteCustomFielpOptions = {
  shouldFetch: boolean;
};

export const useDeleteCustomField = (
  fieldId: string,
  options: TDeleteCustomFielpOptions,
) => {
  const { customFieldApi } = usePrivate();

  const deleteCustomFieldRequest = async (fieldId?: string) => {
    await customFieldApi?.apiCustomFieldDelete(fieldId);
  };

  const results = useSWRMutation(
    options.shouldFetch ? customFieldApi : null,
    () => deleteCustomFieldRequest(fieldId),
  );

  return results;
};
